<template lang="pug">
el-dialog(v-dialogDrag append-to-body title="表单预览" :visible.sync="preview.state"  :before-close="handleClose")
  VFPreview(:class="[layoutType === 'H5'?'h5-layout':'' ]" ref="fcview" :formId="formId" :key="formId" @loadComplete="loadComplete")
</template>

<script>
export default {
  props: {
    layoutType: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      preview: {
        state: false
      },
      formId: ""
    };
  },
  methods: {
    async openDialog(val) {
      this.formId = val;
      this.preview.state = true;
      // await this.$nextTick();
      // const getFieldWidgets = this.$refs.fcview.getFieldWidgets();
      // console.log(getFieldWidgets);
      // debugger;
    },
    loadComplete() {
      console.log("加载完毕");
      this.$emit("getFieldWidgets", this.getFieldWidgets());
    },
    getFieldWidgets() {
      return this.$refs.fcview.getFieldWidgets();
    },
    handleClose() {
      this.preview.state = false;
    }
  }
};
</script>

<style lang="scss">
.h5-layout{
  margin: 10px auto;
  border-radius: 15px;
  box-shadow: 0 0 1px 5px #495060;
  padding: 10px;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  width: 420px;
}
</style>

